<template>
  <div style="display: flex; flex: 1 1 0; min-height: 0; flex-direction: column;">
    <div class="text-center text-h6 pt-4" style="flex: 0 0 auto;">{{ areas.length }} Flächen</div>

    <div style="flex: 1 1 0; min-height: 0; overflow-y: auto;">
      <v-list nav density="compact" class="bg-transparent">
        <v-list-item
          v-for="item in sortedAreas"
          :key="item.id"
          :id="`area-list-item-${item.id}`"
          density="compact"
          prepend-gap="10"
          class="py-1 my-4 bg-transparent"
          :active="item === areaSelected"
          @click="select(item)"
        >
          <template #prepend>
            <v-icon>mdi-map-marker</v-icon>
          </template>

          <div class="list-item-area text-no-wrap text-truncate"><strong>{{ item.address.street }}</strong></div>
          <div class="d-flex justify-space-between align-top text-no-wrap">
            <div class="text-truncate d-block" :title="`${item.address.street}, ${item.address.city}`">
              <div class="list-item-score">{{ item.address.city }}</div>
              <div class="list-item-score"><strong>Score:</strong> {{ round(item.priority_score, 3) }}</div>
            </div>
            <div class="text-right ml-3">
              <v-icon v-if="sortAcceptedFirst" :class="item.accepted ? 'text-success' : 'text-error'">{{ item.accepted ? "mdi-check" : "mdi-close" }}</v-icon>
              <div class="small">#{{ item.id }}</div>
              <div class="list-item-score"><strong>{{ round(item.area_sqm) }} m²</strong></div>
            </div>
          </div>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script setup>
  import { round } from "../../services/number-helpers";
  import { ref, computed, watch } from "vue";

  const props = defineProps({
    report: {
      type: Object,
      required: true
    },
    areas: {
      type: Array,
      required: true
    },
    sortAcceptedFirst: {
      type: Boolean,
      required: false,
      default: false
    }
  });
  const emit = defineEmits(['click']);
  const areaSelected = defineModel();
  const sortedAreas = computed(() => {
    return props.areas.slice().sort((a, b) => {
      if (props.sortAcceptedFirst) {
        const leftAccepted = a.accepted === true;
        const rightAccepted = b.accepted === true;
        if (leftAccepted !== rightAccepted) return leftAccepted ? -1 : 1;
      }

      const leftScore = a.priority_score || 0;
      const rightScore = b.priority_score || 0;
      return rightScore - leftScore;
    });
  });

  watch(() => areaSelected.value, () => {
    if (areaSelected.value) {
      const element = document.getElementById(`area-list-item-${areaSelected.value.id}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  });

  function select(area) {
    areaSelected.value = area;
    emit('click', area);
  }
</script>

<style scoped>
  .small {
    font-size: 0.7rem;
  }
  .list-item-area {
    font-size: 1rem;
  }
  .list-item-score {
    font-size: 0.8rem;
  }
  .translucent-background {
    background-color: rgba(255, 255, 255, 0.9);
  }
</style>